import React, { Component } from 'react'
import Modal from "react-modal"
import Cookies from "universal-cookie"

import Button from '@mui/material/Button';
export default class AddItemToCartModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      quantity: null,
      loading: true,
      quantityAvailable: null
    }
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchAvailableQuantity = this.fetchAvailableQuantity.bind(this);
  }

  openModal(e) {
    e.stopPropagation();
    this.setState({
      modalOpen: true,
    });
    this.fetchAvailableQuantity();
  }

  fetchAvailableQuantity() {
    this.setState({loading: true})
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    const { item } = this.props;
    fetch('/webapi/items/' + this.props.item.id + '/currently_available_and_receiving_count', {
      method: 'GET',
      redirect: "manual",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      this.setState({
        quantityAvailable: json.currently_available_and_receiving,
        loading: false
      })    
    })
  }

  closeModal() {
    this.setState({
      modalOpen:false,
    });
  }

  handleInput(e) {
    this.setState({
      quantity: Number(e.target.value)
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    const {user, item} = this.props;
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/order_items`, {
      method: 'POST',
      redirect: "manual",
      body: JSON.stringify({
        user_id: user.id,
        item_id: item.id,
        quantity: this.state.quantity
      }),
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json);
      if (json.errors == null) {
        const event = new CustomEvent("addToCart", {bubbles: true, detail: {quantity: this.state.quantity}});
        document.dispatchEvent(event);
        this.closeModal();
      } else {
        alert(json.error);
      }
    });
  }

  renderAccessButton() {
    const { accessButton } = this.props;
    if (accessButton) {
      return (
        <div onClick={this.openModal}>
          {accessButton}
        </div>
      )
    }
    return (
      <Button color="green" variant="contained" onClick={this.openModal}>
        Add To Order
      </Button>
    )
  }


  render() {
    const { item } = this.props;
    console.log(this.state)
    return(
      <React.Fragment>
        {this.renderAccessButton()}
        <Modal
          className="react-modal item-card-quick-view-modal"
          overlayClassName="react-modal-overlay"
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel="Item Quickview"
        >
          <div className="react-modal-close-button" onClick={this.closeModal}> &#10005; </div>
          <h1>Add {item.name} to Cart</h1>
          <p>Enter Quantity</p>
          {this.state.loading && (
              <div className="sg-mgmt-loading-container">
                <div className="sg-mgmt-loading" />
              </div>
          )}
          {!this.state.loading && (
            <form onSubmit={this.handleSubmit}>
              <input onChange={this.handleInput} className="form-control" type="number" max={this.state.quantityAvailable} min="1" value={this.state.quantity}/>
              <div style={{display: "flex", paddingTop: "10px", justifyContent: "space-around"}}>
                <button className='item-hold-form-submit-button'>Add to Cart</button>
                <button className='item-hold-form-cancel-button' onClick={this.closeModal}>Cancel</button>
              </div>
            </form>
          )}
   
        </Modal>
      </React.Fragment>
    )
  }
}
